export const normalizeTeacher = (teacher) => {

  const subjects =
    teacher.subjects ||
    (teacher.subject ? [teacher.subject] : []);

  return {
    id: teacher.id || teacher.uid || teacher.teacherId,

    name:
      teacher.name ||
      `${teacher.firstName || ""} ${teacher.lastName || ""}`.trim(),

    subjects,

    subject: subjects[0] || "General",

    availability: teacher.availability || "available",

    rating: teacher.rating || "New",

    experience: teacher.experience || "Not specified",

    bio: teacher.bio || "",

    badges: teacher.badges || []
  };

};